import { EBlankFormIcType, EBlankFormInternalAgentType, EBlankFormOtherFeeType, EBLankFormReferralFormula, EBlankFormReferralType, EBlankFormStatus } from '../enums/blank_form.enum';
import { IBlankForm } from '../interfaces/blank-form.interface';
import { IBlankFormIc, IBlankFormIcDescription, IBlankFormInternalAgentTypeDescription, IBlankFormOtherTypeDescription, IBlankFormReferralFormulaDescription, IBlankFormReferralTypeDescription } from '../interfaces/blank-form-ic.interface';
import { IBlankFormReferral } from '../interfaces/blank-form-referral.interface';
import { IBlankFormRelatedAgent } from '../interfaces/blank-form-related-agent.interface';
import { StatusRecord } from './status.type';

export type KeysOfBlankFormExtend<T> = {
  [K in keyof Required<IBlankForm>]: IBlankForm[K] extends T ? K : never;
}[keyof IBlankForm];

export type BlankFormStatusRecord = StatusRecord<EBlankFormStatus>;

export type BlankFormIcRecord = Record<EBlankFormIcType, IBlankFormIcDescription>;

export type BlankFormReferralTypeRecord = Record<EBlankFormReferralType, IBlankFormReferralTypeDescription>;

export type BlankFormReferralFormulaRecord = Record<EBLankFormReferralFormula, IBlankFormReferralFormulaDescription>;

export type BlankFormInternalAgentTypeRecord = Record<EBlankFormInternalAgentType, IBlankFormInternalAgentTypeDescription>;

export type BlankFormOtherFeeTypeRecord = Record<EBlankFormOtherFeeType, IBlankFormOtherTypeDescription>;

export type KeysOfBlankFormExtendBlankFormIcs = KeysOfBlankFormExtend<IBlankFormIc[]>;

export type KeysOfBlankFormExtendReferrals = KeysOfBlankFormExtend<IBlankFormReferral[]>;

export type KeysOfBlankFormHaveAgent = keyof IBlankFormRelatedAgent | KeysOfBlankFormExtendBlankFormIcs | KeysOfBlankFormExtendReferrals;
